import { useRouter } from "next/router";

export const usePage = (): number => {
  const router = useRouter();

  return +((router.query["page"] as string) ?? "") || 1;
};
